import posthog from "posthog-js"
import { getCookieConsent } from "@/utils/cookie_utils"

export default {
  install(Vue, options) {
    // Initialize PostHog with capturing disabled by default
    Vue.prototype.$posthog = {
      // noop tracking, the best kind!
      capture() {},
      get_distinct_id() { return "No Logs, No Masters!"; }
    }

    // If the user has previously given analytics consent in localStorage, opt-in
    const consent = getCookieConsent()
    if (consent && consent.preferences && consent.preferences.analytics) {
      Vue.prototype.$posthog.opt_in_capturing()
    }
  },
}
